<template>
    <v-switch
        class="compact"
        color="primary" 
        :input-value="value" 
        @change="$emit('change', $event)"
        :label="schema.label" 
        :hide-details="false" 
        :hint="schema.hint" 
        :placeholder="schema.placeholder"
        outlined dense
    />
</template>

<script>



export default {

    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        value: Boolean,
        schema: Object, 
    },

    computed: {

    },

    methods: {

    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// SwitchControl.vue?30d2db48